import React, { useContext, useEffect } from 'react';
import Item from '../components/items/item'
import './css/favourites.css'
import { ShopContext } from '../context/shopContext';


const Favourites = () => {
    const { favourites } = useContext(ShopContext);

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);

    return (
        <div className='favourites'>
            <div className='favourite-item'>
                {favourites && favourites.length > 0 ? (
                    favourites.map((product, index) => (
                        <Item
                            key={index}
                            id={product._id}
                            name={product.name}
                            image={product.image}
                        />
                    ))
                ) : (
                    <p className='favs-message'>
                        Go! Add a Bastard Card to your favourites and give into the dark side...
                    </p>
                )}
            </div>
        </div>
    );
};


export default Favourites;



